import _taggedTemplateLiteral from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

import styled, { css } from 'styled-components';
var colors = {
  default: '#4B4B4B',
  error: '#FC4949',
  success: '#4AC326',
  primary: '#1C2EB8',
  neutral: '#898989',
  disabled: '#C3C3C3'
};

function handleHelperMessageColor(variant) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), colors[variant] || colors.default);
}

function handleBorderColor(focused, hasError) {
  if (hasError) {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n    "])), colors.error);
  }

  if (focused) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      border: 2px solid ", ";\n    "])), colors.primary);
  }

  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n  "])), colors.disabled);
}

function handleFloatingLabelColor(isFloating, focused, hasError) {
  if (hasError && isFloating) {
    return "color: ".concat(colors.error, ";");
  }

  if (isFloating && focused) {
    return "color: ".concat(colors.primary, ";");
  }

  return "color: ".concat(colors.neutral, ";");
}

function handleFloatingLabelPosition(isFloating, hasIcon) {
  if (isFloating && hasIcon) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      transform: translate(18px, -12px);\n    "])));
  }

  if (isFloating && !hasIcon) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      transform: translate(48px, -12px);\n    "])));
  }

  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    transform: translate(48px, 18px);\n  "])));
}

export var RootContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n"])));
export var TextFieldClearButton = styled.button(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  padding: 0;\n  bottom: 50%;\n  transform: translateY(50%);\n  right: 10px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: ", ";\n  line-height: 0;\n\n  &:hover {\n    > svg {\n      filter: brightness(1.1);\n    }\n  }\n"])), function (_ref) {
  var visible = _ref.visible;
  return visible ? 'block' : 'none';
});
export var TextFieldIconWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 50%;\n  transform: translateY(50%);\n  left: 16px;\n  line-height: 0;\n  z-index: 1;\n"])));
export var TextFieldLabel = styled.label(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var isFloating = _ref2.isFloating,
      hasIcon = _ref2.hasIcon,
      hasError = _ref2.hasError,
      focused = _ref2.focused;
  return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    transform-origin: left top;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: ", ";\n    position: absolute;\n    left: ", ";\n    top: ", ";\n    transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    z-index: 1;\n    pointer-events: ", ";\n    ", "\n\n    p {\n      font-size: ", "px;\n      ", "\n    }\n  "])), isFloating ? 'calc(133% - 32px)' : 'calc(100% - 24px)', hasIcon ? '0' : '-32px', isFloating ? '3px' : '-2px', isFloating ? 'auto' : 'none', handleFloatingLabelPosition(isFloating, hasIcon), isFloating ? 11 : 15, handleFloatingLabelColor(isFloating, focused, hasError));
});
export var TextFieldInput = styled.input(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  border: 0px;\n  border-radius: 5px;\n  height: 48px;\n  margin: 0px;\n  display: block;\n  min-width: 0px;\n  width: 100%;\n  font-size: 15px;\n  font-family: inherit;\n  color: ", ";\n  padding-left: ", ";\n  font-family: 'Ubuntu';\n\n  &:focus {\n    outline: 0px;\n  }\n\n  &::placeholder {\n    font-size: 14px;\n    color: ", ";\n  }\n"])), colors.default, function (props) {
  return props.hasStartIcon ? '48px' : '18px';
}, colors.neutral);
export var TextFieldLegend = styled.legend(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  float: unset;\n  width: ", "px;\n  margin-left: -5px;\n  display: block;\n  padding: 0px;\n  height: 11px;\n  font-size: 12px;\n  visibility: hidden;\n  max-width: ", ";\n  transition: ", ";\n  white-space: nowrap;\n"])), function (props) {
  return props.floatingLabelWidth + 5;
}, function (_ref3) {
  var isFloating = _ref3.isFloating;
  return isFloating ? '100%' : '0.01px';
}, function (_ref4) {
  var isFloating = _ref4.isFloating;
  return isFloating ? 'max-width 50ms cubic-bezier(0, 0, 0.2, 1) 0ms, visibility 50ms cubic-bezier(0, 0, 0.2, 1) 0ms' : ' max-width 100ms cubic-bezier(0, 0, 0.2, 1) 0ms;';
});
export var TextFieldFieldsetWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.4375em;\n  letter-spacing: 0.00938em;\n  color: ", ";\n  box-sizing: border-box;\n  cursor: text;\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  position: relative;\n  border-radius: 10px;\n\n  &:hover {\n    > fieldset {\n      border-color: ", ";\n    }\n  }\n"])), colors.neutral, function (props) {
  return props.hasError ? colors.error : colors.primary;
});
export var TextFieldFieldset = styled.fieldset(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  text-align: left;\n  position: absolute;\n  border-radius: 5px;\n  inset: -5px 0px 0px;\n  margin: 0px;\n  padding: 0px 18px;\n  pointer-events: none;\n  overflow: hidden;\n  min-width: 0%;\n  ", "\n"])), function (props) {
  return handleBorderColor(props.focused, props.hasError);
});
export var TextFieldHelperMessage = styled.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  ", "\n  font-family: 'Ubuntu', sans-serif;\n  margin: 0;\n  width: 100%;\n  margin-top: 5px;\n  font-size: 12px;\n"])), function (_ref5) {
  var variant = _ref5.variant;
  return handleHelperMessageColor(variant);
});